<template>
	<v-sheet>
		<v-card-title v-if="title" class="d-flex align-center">
			{{ title }}
			<v-icon color="info" @click="load">$reload</v-icon>
		</v-card-title>
		<v-card-text class="pt-0">
			<v-form @submit.prevent="search" class="form-inline">
				<v-row class="">
					<v-col cols="12" sm="4">
						<v-text-field
							outlined
							dense
							v-model="query.name"
							label="名称"
						/>
					</v-col>
					<v-col cols="12" sm="3">
						<v-select
							outlined
							dense
							label="类型"
							v-model="query.type"
							:items="refs['TYPELABEL']"
							clearable
						></v-select>
					</v-col>
					<v-col cols="12" sm="2">
						<v-select
							outlined
							dense
							label="状态"
							v-model="query.status"
							:items="refs['STATUSLABEL']"
							clearable
						></v-select>
					</v-col>
					<v-col cols="12" sm="3">
						<v-btn color="primary" type="submit"
							><v-icon>$search</v-icon>查询</v-btn
						>
						<v-btn text v-if="queryPairs.length > 0"
							><v-icon @click="reset">$close</v-icon></v-btn
						>
					</v-col>
				</v-row>
			</v-form>

			<v-data-table
				:headers="headers"
				:items="objects"
				:options.sync="options"
				:server-items-length="parseInt(total)"
				:loading="loading"
				:show-select="showSelect"
				:single-select="singleSelect"
				v-model="selected"
				:footer-props="{
					showFirstLastPage: true,
					showCurrentPage: true,
					itemsPerPageOptions: [10, 20, 30]
				}"
			>
				<template v-slot:top>
					<slot name="batchActions" v-bind:selected="selected"></slot>
				</template>
				<template v-slot:item.action="{ item }">
					<slot name="actions" v-bind:item="item"></slot>
				</template>
				<template v-slot:footer>
					<slot name="batchActions" v-bind:selected="selected"></slot>
				</template>
			</v-data-table>
		</v-card-text>
	</v-sheet>
</template>

<script>
import UserSelector from '../user/Selector.vue'
import { clone, valuesIn, toPairsIn, filter, intersection } from 'lodash-es'

export default {
	components: { UserSelector },
	props: {
		initQuery: { type: Object, default: null },
		title: { type: String, default: null },
		showSelect: { type: Boolean, default: false },
		singleSelect: { type: Boolean, default: true },
		headers: {
			type: Array,
			default: () => [
				{ text: '#', value: 'id' },
				{
					text: '名称',
					align: 'left',
					sortable: true,
					value: 'name'
				},
				{ text: '联系人', value: 'contact' },
				{ text: '位置', value: 'address' },
				{ text: '类型', value: 'type' },
				{ text: '状态', value: 'status' },
				{
					text: '操作',
					align: 'left',
					sortable: false,
					value: 'action'
				}
			]
		}
	},
	data() {
		return {
			query: {}, //查询条件（还未点击查询按钮）
			currentQuery: {}, //当前结果的查询条件
			objects: [],
			total: 0,
			loading: false,
			options: {},
			refs: {},
			selected: [],
			errors: {}
		}
	},
	mounted() {
		let self = this
		this.$api.common.getMeta('Shop', 'STATUSLABEL,TYPELABEL', (r) => {
			self.refs = r
		})
		if (this.initQuery) {
			this.query = clone(this.initQuery)
		}
	},
	computed: {
		queryValues() {
			return filter(valuesIn(this.query), (e) => !!e)
		},
		currentQueryValues() {
			return filter(valuesIn(this.currentQuery), (e) => !!e)
		},
		queryPairs() {
			return filter(toPairsIn(this.query), (e) => !!e[1])
		}
	},
	watch: {
		options: {
			handler() {
				this.load()
			},
			deep: true
		}
	},
	methods: {
		search() {
			if (
				this.queryValues.length !== this.currentQueryValues.length ||
				intersection(this.queryValues, this.currentQueryValues)
					.length !== this.queryValues.length
			) {
				//条件变化
				if (this.options.page === 1) {
					//当前如果是第一页，手动触发
					this.load()
				} else {
					this.options.page = 1 //当前不是第一页，修改后通过watcher触发
				}
			} else {
				//条件没变，忽略
			}
		},
		reset() {
			this.query = {}
		},
		load() {
			let { sortBy, sortDesc, page, itemsPerPage } = this.options
			this.loading = true
			let self = this
			let qwp = clone(this.query)
			qwp.pageno = page
			qwp.pagesize = itemsPerPage
			qwp.sortBy = 'id'
			if (sortBy.length > 0) qwp.sortBy = sortBy[0]
			qwp.sortDesc = 'desc'
			if (sortDesc.length > 0)
				qwp.sortDesc = sortDesc[0] === false ? 'asc' : 'desc'
			this.currentQuery = clone(this.query)
			this.$api.shop.search(
				qwp,
				(response) => {
					self.objects = response.objects
					self.total = response.total
					self.loading = false
				},
				(error) => {
					// console.log(error);
					self.loading = false
				}
			)
		}
	}
}
</script>

<style scoped>
.silent td {
	color: rgba(3, 3, 3, 0.5) !important;
}
</style>
